import Vue from 'vue'
import VSelect from 'vue-select'

import 'vue-select/src/scss/vue-select.scss'

// vSelect.props.components.default = () => ({
//   Deselect: {
//     render: createElement => createElement('span', {
//       class: 'fad fa-close'
//     }),
//     hack: {
//       listeners: {
//         onload: args => {
//         }
//       }
//     }
//   }
// })

Vue.component('VSelect', VSelect)
